/* istanbul ignore file */
export enum DownloadPageType {
    Accounts,
    ACH,
    AchTemplates,
    AchExceptions,
    CheckExceptions,
    ResearchTransactions,
    Loans,
    StopPayments,
    Transfers,
    TransferTemplates,
    WireCreditors,
    WireTemplates,
    Wires,
    WireFiles,
}
